import { Navigate, Outlet } from 'react-router';
import { useSession } from '../auth.js';
import { LoadingSpinner } from './ui/LoadingSpinner.js';

/**
 * Route guard: gates the authenticated app behind a Better-Auth session.
 * While the session is resolving, show a spinner; with no session, redirect to
 * /login. Children render via <Outlet/> only when authenticated.
 */
export default function RequireAuth() {
  const { data: session, isPending } = useSession();

  if (isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
